import * as React from 'react';
import { useEffect, useState } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
/**
 * @typedef {import('../../App.d.ts').ComponentLoginButtonProps} ComponentLoginButtonProps
 */
/**
 * @param {ComponentLoginButtonProps} props
 * @returns {Element}
 * @constructor
 */

export default ({ label, loginHint }) => {
  const [href, setHref] = useState('/login');
  useEffect(() => {
    const url = new URL(location.href);
    const currentPageQuery = new URLSearchParams(url.searchParams);
    const query = new URLSearchParams();

    const returnTo = currentPageQuery.get('returnTo');
    if (returnTo) {
      query.set('returnTo', returnTo);
    }

    if (loginHint) {
      query.set('kc_idp_hint', loginHint);
    }

    // variable used to "cache" the result of toString()
    // so we dont have to call it multiple times
    const q = query.toString();
    const queryString = q ? `?${q}` : '';
    setHref(`/login${queryString}`);
  }, [loginHint]);

  return (
    <div
      data-testid="login-button"
      className="dodo-login-button"
    >
      <Button
        href={href}
        icon={<IconAsChunk iconName="Login" />}
        rawElementProps={{
          'data-test-id': 'component-login-button',
        }}
      >
        {label}
      </Button>
    </div>
  );
};
